<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="400px"
    :innerScroll="false"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="120px" v-loading="loading">
     <el-row>
			<el-col :span="24">
				<el-form-item label="低于A类价(%):" prop="priceRatio">
				  <el-input  v-model.trim="addForm.priceRatio" @input="buyPriceInput('priceRatio')"  size="small"></el-input>
				</el-form-item>
			</el-col>
     </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import moment from 'moment'
import axios from '@/utils/axiosInstance'
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false
    },
    priceRatio: String,

  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    title() {
      return '配置'
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      rules: {
        priceRatio: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
    },
    onConfirm() {
      if(this.addForm.priceRatio == this.priceRatio) {
        this.onCancel()
        return
      }
      let _this = this
      this.$refs.addForm.validate((valid) => {
        if (!valid) return
          const loading = this.$loading({
          lock: true,
          text: '配置正在同步中',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        let data = {
          ...this.addForm,
        }
        this.$q.smallHomeAppliances.configRatioUpdate({ data: data }).then((res) => {
          var timer = setInterval(function() {
            _this.$q.common.reportTaskInfo({fragment: [res.message]}).then(res => {
              if(res.data.taskStatus == '执行完成') {
                clearInterval(timer)
                loading.close()
                let text = _this.title + '成功'
                _this.$message.success(text);
                _this.isVisible = false
                _this.$emit('success') 
              }
            }).catch(err => {
              this.$message.error(err.message);
            })
          },5000)
        })
      })
    },
    async init() {
    },
    //只能输入正数并小数点保留1位
    buyPriceInput(name) {
       var price = '' + this.addForm[name];
      price = price
          .replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
          .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
          .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'); // 只能输入两个小数
      if (price.indexOf('.') < 0 && price != '') {
          // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
          price = parseFloat(price);
      }
      this.addForm[name] = price;
    },
  },
  created() {
    this.$set(this.addForm,'priceRatio',this.priceRatio)
  },
}
</script>

<style lang="stylus" scoped>

>>> .el-input--small .el-input__inner, >>> .el-input--suffix .el-input__inner, >>> .el-input--suffix {
  height: 32px;
  line-height: 32px;
  width: 170px !important;
}

>>> .el-date-editor.el-input {
  width: 170px
}

>>> .el-select .el-input .el-select__caret {
  height: 32px;
  line-height: 32px;
}

>>> .el-textarea .el-input__count {
    background: transparent;
    height: 28px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form-item__content .textTips {
  cursor: pointer
  height: 40px
  overflow: hidden
  white-space: nowrap;
  text-overflow: ellipsis
}

.remark >>> .el-form-item__label {
  line-height: 26px
}
</style>